function createLazyPromise(executor) {
  const holder = {
    resolve(_) {
      throw new Error("pending resolve");
    },
    reject(_) {
      throw new Error("pending reject");
    }
  };
  const future = Object.assign(
    new Promise((resolve, reject) => {
      holder.reject = reject;
      holder.resolve = resolve;
    }),
    {
      resolve(v) {
        holder.resolve(v);
      },
      reject(v) {
        holder.resolve(v);
      }
    }
  );
  if (executor) {
    const r = holder.resolve;
    let shouldExec = true;
    holder.resolve = (v) => {
      shouldExec = false;
      r(v);
    };
    const then = future.then.bind(future);
    future.then = (...args) => {
      if (shouldExec) {
        shouldExec = false;
        executor(holder.resolve, holder.reject);
      }
      return then(...args);
    };
    const like = holder;
    like.then = future.then;
    like.catch = future.catch.bind(future);
    if (future.finally)
      like.finally = future.finally;
    void Object.defineProperty(like, Symbol.species, {
      get() {
        return Promise;
      }
    });
    return like;
  }
  return future;
}

export { createLazyPromise };
//# sourceMappingURL=createLazyPromise.js.map
